export const scrollIntoView = async () => {
    setTimeout(() => {
        const activeTab = document.getElementById("sport-market-list-scroller")?.getElementsByClassName("sport-market-list-active")[0];
        if (activeTab) {
            activeTab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
        }
    }, 100);
};